import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {Contact} from "../../model/contact";
import {FormGeneratorService} from "../../components/common/fields/form-generator.service";
import {FieldDefinition} from "../../model/field-definition";

@Injectable({
  providedIn: 'root'
})
export class UserProfileFormGeneratorService implements FormGeneratorService {

  constructor() {
  }

  getQuestions(user: Contact, profileOnly: boolean = false): Observable<FieldDefinition<any>[]> {
    const questions = [];
    if (!profileOnly) {
      questions.push(new FieldDefinition<string>({
        key: "function",
        label: 'Fonction au sein de la structure',
        type: 'text',
        placeholder: 'Exemple: DSI, Archiviste, ...',
        required: true,
        order: 1
      }));
    }
    questions.push(new FieldDefinition<string>({
      key: "profile",
      label: 'Profil',
      value: user ? (user.referent ? 'Referent' : 'Simple') : '',
      type: 'btn-radio',
      info: 'Pour plus de détails entre utilisateur simple et utilisateur référent Portail, veuillez cliquer sur l\'un des boutons ci-dessus',
      options: [
        {key: 'Simple', value: "Utilisateur simple"},
        {key: 'Referent', value: "Utilisateur référent Portail"},
      ],
      required: true,
      order: 2
    }));

    return of(questions.sort((a, b) => a.order - b.order));
  }
}
